import { render, staticRenderFns } from "./ContentTranslationDetails.vue?vue&type=template&id=57585888&"
import script from "./ContentTranslationDetails.vue?vue&type=script&lang=js&"
export * from "./ContentTranslationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports